import { Check } from "lucide-react";

export const WizardSidePanel = ({ step }) => (
    <div className="lg:col-span-5 p-8 sm:p-10 border-b lg:border-b-0 lg:border-r border-white/10 relative">
        <div
            className="pointer-events-none absolute -bottom-10 -left-10 w-48 h-48 rounded-full blur-3xl"
            style={{ background: "rgba(20,184,166,0.12)" }}
        />
        <span className="font-mono text-xs text-neon tracking-[-0.01em]">
            // CONTACT US
        </span>
        <h2 className="font-mono tracking-[-0.01em] text-3xl font-semibold text-white mt-3 leading-tight">
            Let's get you connected.
        </h2>
        <p className="font-body text-sm text-white/55 mt-4 leading-relaxed">
            Two quick steps. Share your contact details, then tell us where the
            friction is — we'll prepare a tailored AI optimisation brief.
        </p>

        <div className="mt-10 flex items-center gap-3">
            {[1, 2].map((s) => (
                <div key={s} className="flex items-center gap-3">
                    <span
                        data-testid={`step-indicator-${s}`}
                        className={`w-8 h-8 rounded-full flex items-center justify-center font-mono text-xs transition-all ${
                            step >= s
                                ? "bg-neon text-black"
                                : "bg-white/10 text-white/50"
                        }`}
                    >
                        {step > s ? <Check size={14} /> : s}
                    </span>
                    {s === 1 && <span className="w-10 h-px bg-white/15" />}
                </div>
            ))}
            <span className="font-mono text-xs text-white/40 ml-1">
                STEP {step} / 2
            </span>
        </div>
    </div>
);
